import React from 'react'

import {
  Profile as _Profile,
  GoggleIcon,
  ProfileName,
} from './order-item.styles'

export const Profile = ({
  profileName,
  className,
}: {
  profileName: string
  className?: string
}) => {
  return (
    <_Profile className={className}>
      <GoggleIcon glyph="user" />
      <ProfileName data-testid="profile-name">{`${profileName}`}</ProfileName>
    </_Profile>
  )
}
